const debounce = (callback: () => void, timeout = 1000): (() => void) => {
  let called = false;

  const fn = () => {
    if (!called) {
      called = true;
      callback();
    }
  };

  setTimeout(fn, timeout || 1000);
  return fn;
};

export default debounce;
